import styled from 'styled-components'
import { components } from 'react-select'

import { InnerComponent } from 'components/utils/innerReactSelectComponents'
import colors from 'components/utils/colors'

import { StyledDropdownIndicator } from 'components/Shared/InlineSelect/components/DropdownIndicator'

const StyledControl = styled(InnerComponent).attrs({ Component: components.Control })`
  &.react-select__control {
    font-size: 12px;
    line-height: 16px;
    min-height: 16px;
    box-shadow: none;
    cursor: pointer;
    border-style: none;
    flex-wrap: nowrap;
  }

  &:hover, &.react-select__control--menu-is-open {
    ${StyledDropdownIndicator} {
      color: ${colors.primary40};
    }
  }

  &.react-select__control--is-disabled {
    background-color: #FFFFFF;

    .react-select__placeholder {
      color: ${colors.secondary80};
    }
  }

  .react-select__placeholder {
    color: ${colors.secondary20};
  }
`

const SelectControl = (props) => {
  return (
    <StyledControl {...props} />
  )
}

export default SelectControl
